import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18next'

import { ApplicationState } from '@/state/root.models'
import { RestApiService } from '@/services'
import {
  setSnackbarAction,
  setLoadingFullAction,
} from '@/state/ui/global/slices/index.slices'

import { BONUS_PROGRAMS } from './api.routes'
import ActionTypes from '../constants'
import { BonusesResponse, BonusEngineState } from '../models'

const restApiService: RestApiService = Container.get(RestApiService)

export const getAllBonusesByBundleThunk = createAsyncThunk(
  ActionTypes.GET_ALL_BONUSES_BY_BUNDLE,
  async (_, thunkAPI) => {
    try {
      restApiService.requestParams = {
        method: 'GET',
        endpoint: BONUS_PROGRAMS.FIND_ALL,
        queries: 'triggersBy=4',
      }

      const { auth } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: BonusesResponse = await restApiService.getData(
        auth.brand.siteId.toString(),
        auth.token,
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      if (response.status && response.status !== 200) {
        const message =
          typeof response.message === 'string'
            ? response.message
            : i18n.t('messages.errorOccurred')

        thunkAPI.dispatch(
          setSnackbarAction({
            message,
            open: true,
            variant:
              response?.status && response?.status !== 200
                ? 'error'
                : 'success',
          }),
        )
      }

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      throw error
    }
  },
)

const getAllBonusesByBundleExtraReducer = (
  builder: ActionReducerMapBuilder<BonusEngineState>,
) => {
  builder.addCase(getAllBonusesByBundleThunk.pending, (state) => {
    state.isLoading = true
  })
  builder.addCase(
    getAllBonusesByBundleThunk.fulfilled,
    (state, { payload }) => {
      state.isLoading = false
      state.bonusesByBundle = payload.docs
        ? payload.docs
            .filter((item) => item.isActive)
            .map((item) => {
              return {
                _id: item.code ? item.code.toString() : '',
                name: item.name || '',
              }
            })
        : []
    },
  )
}

export default getAllBonusesByBundleExtraReducer
